import { useSyncExternalStore } from "react";
import {
	isClientOutdated,
	subscribeClientOutdated,
} from "@/lib/__shared__/clientOutdated";

/**
 * Reflects whether this client bundle is behind the server contract, set by
 * either the deployed-version poll or the apiClient `CLIENT_OUTDATED`
 * interceptor. Latches true; a reload is the only reset.
 */
export const useClientOutdated = (): boolean =>
	useSyncExternalStore(
		subscribeClientOutdated,
		isClientOutdated,
		isClientOutdated,
	);
